import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamRecurrenceMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamRecurrenceMetric | null;
}

export const TeamIncidenceByRoleChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => b.totalInjuries - a.totalInjuries)
    .map((d) => ({
      pos: d.position ?? 'N/D',
      infortuni: d.totalInjuries,
    }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="pos" tick={chartAxisTick} />
        <YAxis
          tick={chartAxisTick}
          label={{ value: 'Infortuni', angle: -90, position: 'insideLeft', offset: 20, style: { fontSize: 10, fill: 'var(--c-text-1)' } }}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v) => [`${v} infortuni`, 'Incidenza']}
        />
        <Bar dataKey="infortuni" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
